<template>
  <div class="row">
    <div class="col-12">
      <vehicle-table />
    </div>
  </div>
</template>

<script>
import VehicleTable from "@/views/components/vehicles/table";
export default {
  name: "VehicleList",
  components: { VehicleTable },
};
</script>
